const i18nProvider = (locale) => {
  // eslint-disable-next-line
  const localMessages = require(`./${locale}.messages.json`);

  return localMessages;
};

export default i18nProvider;
